import { CheckCircle2, CircleDot, Clock, Lock, ShieldCheck, XCircle } from 'lucide-react';
import type { TrainingWaiting } from '../../services/api';

/** What an item waits on, and why — shared by the Pipeline and Campaign pages. */
const STYLE: Record<TrainingWaiting['kind'], { cls: string; Icon: typeof Lock; label: string }> = {
  gate: { cls: 'text-red-700 dark:text-red-400', Icon: Lock, label: 'Blocked by gate' },
  approval: { cls: 'text-amber-700 dark:text-amber-400', Icon: ShieldCheck, label: 'Needs approval' },
  pending_approval: { cls: 'text-amber-700 dark:text-amber-400', Icon: Clock, label: 'Awaiting approval' },
  ready: { cls: 'text-sky-700 dark:text-sky-400', Icon: CircleDot, label: 'Ready' },
  done: { cls: 'text-emerald-700 dark:text-emerald-400', Icon: CheckCircle2, label: 'Done' },
  cancelled: { cls: 'text-gray-500', Icon: XCircle, label: 'Closed' },
};

export default function Waiting({ waiting, compact = false }: { waiting: TrainingWaiting; compact?: boolean }) {
  const s = STYLE[waiting.kind] || STYLE.ready;
  const next = waiting.toLabel || waiting.to;
  return (
    <div className={`text-xs ${s.cls} flex items-start gap-1.5`}>
      <s.Icon className="w-3.5 h-3.5 mt-0.5 shrink-0" />
      <span>
        <strong>{s.label}</strong>
        {next && waiting.kind !== 'done' && waiting.kind !== 'cancelled' ? <> → {next}</> : null}
        {waiting.gate ? <> · <code>{waiting.gate}</code></> : null}
        {!compact && waiting.reason ? <span className="block text-gray-600 dark:text-gray-400">{waiting.reason}</span> : null}
      </span>
    </div>
  );
}

export function StatusPill({ label, color }: { label: string; color?: string }) {
  return (
    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200">
      <span className="w-2 h-2 rounded-full" style={{ background: color || '#94a3b8' }} />
      {label}
    </span>
  );
}
